import React, { useState, useEffect } from 'react';
import hectorLogo from '../hector-logo.svg';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const navbarHeight = 80;
      const targetPosition = element.offsetTop - navbarHeight - 20;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed w-full top-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100 transition-all duration-300 ${isScrolled ? 'navbar-scrolled' : ''}`}>
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
         <img
  src={hectorLogo}
  alt="Hector Logo"
  className="h-12 w-auto object-contain"
/>

          </div>
          
          <div className="hidden md:flex items-center space-x-8">
     
 <a
  href="https://hector.partnerstack.com/"
  target="_blank"
  rel="noopener noreferrer"
  className="cta-button px-8 py-4 rounded-xl font-semibold text-white text-base shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 inline-block"
  style={{
    background: "linear-gradient(90deg, #CC2EF4 0%, #3E2EF4 100%)",
  }}
>
  Join Now
</a>


          </div>
          
 
        </div>
      </div>
      
    </nav>
  );
};

export default Navbar;
